export function phoneForLinks(phoneNumber: string) {
  const charactersToReplace = ['-', ' ', '/', '(0)'];

  charactersToReplace.forEach(char => {
    if (phoneNumber.includes(char)) phoneNumber = phoneNumber.replaceAll(char, '');
  });

  if (phoneNumber.startsWith('0')) phoneNumber = phoneNumber.replace('0', '+49');

  return phoneNumber;
}
